export default "__VITE_ASSET__b8bc518a__"